import {useMemo} from 'react';

import {useMyPending} from 'app/modules/tickets/hooks/useMyPendingCount';
import {
  PendingArrival,
  useNeedsActionReach,
} from 'app/modules/tickets/hooks/useNeedsActionReach';
import {NEEDS_ACTION_URL} from 'app/modules/tickets/ticketsLinks';

import {HeaderNotification, ticketNotification} from './headerNotifications';

export type HeaderNotificationsState = {
  /** Os mais recentes primeiro. */
  items: HeaderNotification[];
  status: 'loading' | 'error' | 'ready';
  retry: () => void;
  /** Chegou notificação nova: o sino anima. */
  arrival: PendingArrival | null;
  /** "Ver todos". */
  allTo: string;
};

/**
 * Fonte do sino. Hoje: os tickets que precisam da ação da pessoa, da mesma
 * consulta (e do mesmo polling) que já dava a contagem de pendentes, com o
 * alcance de sempre (badge no título da aba, aviso do sistema operacional).
 */
export const useHeaderNotifications = (): HeaderNotificationsState => {
  const pending = useMyPending();
  const arrival = useNeedsActionReach(pending.data?.total);
  const items = useMemo(
    () => (pending.data?.items || []).map(ticketNotification),
    [pending.data]
  );
  const {refetch} = pending;
  return {
    items,
    status: pending.data ? 'ready' : pending.isError ? 'error' : 'loading',
    retry: () => {
      void refetch();
    },
    arrival,
    allTo: NEEDS_ACTION_URL,
  };
};
